module.exports = __webpack_public_path__ + "static/bar02_1-4445001ca2feb28be350da460e1e8c3b.png";